// 使用事件委托处理动态加载的弹窗触发器
document.addEventListener('click', function(e) {
    // 检查点击的是否是popup-trigger元素或其子元素
    let trigger = e.target.closest('.popup-trigger');
    if (!trigger) return;
    
    e.preventDefault();
    
    const id = trigger.getAttribute("data-popup-id");
    const styleClass = trigger.getAttribute("data-popup-style-name") || "";

    const template = document.getElementById(id);
    if (!template) return;

    const popupOverlay = document.createElement("div");
    popupOverlay.className = "popup-overlay";
    if (styleClass) {
        popupOverlay.classList.add(styleClass);
    }

    const popupBox = document.createElement("div");
    popupBox.className = "popup-box";

    // 创建可滚动内容容器
    const scrollable = document.createElement("div");
    scrollable.className = "popup-scrollable";

    // 克隆模板内容并添加到可滚动区域
    const content = template.content.cloneNode(true);
    scrollable.appendChild(content);

    // 添加可滚动区域到弹窗盒子
    popupBox.appendChild(scrollable);

    // 创建关闭按钮
    const closeButton = document.createElement("button");
    closeButton.innerHTML = "&times;";
    closeButton.className = "popup-close";
    closeButton.onclick = () => document.body.removeChild(popupOverlay);

    popupBox.appendChild(closeButton);
    popupOverlay.appendChild(popupBox);
    document.body.appendChild(popupOverlay);
});